import { render, staticRenderFns } from "./GalleryChildProfileFolder.vue?vue&type=template&id=386d9469"
import script from "./GalleryChildProfileFolder.vue?vue&type=script&lang=js"
export * from "./GalleryChildProfileFolder.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports